export class BreadcrumbItem {
    name: string;
    routerLink: any[] | string;
    queryParams?: any;
}

export type BreadcrumbDef = BreadcrumbItem[];
